import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ConfigurationServices } from '../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the DishPartialIngredientsSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-variations-partial-fav-selected',
  templateUrl: 'variations-partial-fav-selected.html',
})
export class VariationsPartialFavSelectedPage {
  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,) {

  }

  delete(element) {
    var index = this.configurationServices.fav_variations_array_tmp.findIndex(x => x[0] == element[0]);
    if (index >= 0) {
      this.configurationServices.fav_variations_array_tmp.splice(index, 1);
      this.configurationServices.fav_variations_array_tmp = [...this.configurationServices.fav_variations_array_tmp];
    }
  }
  clickElement(event) {
    if (event.type == 'click') {
      this.delete(event.row);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/variations/variations-create-fav-select/variations-partial-fav-selected/variations-partial-fav-selected.ts